import { useState } from 'react';
import { koboToNaira } from '../lib/format';
import type { BalanceRow } from './AccountBar';

interface Props {
  balance?: BalanceRow;
  accountLabel: string;
  pnlDayKobo?: string;
  pnlOpenKobo?: string;
  positionsValueKobo?: string;
}

export function AccountSummary({ balance, accountLabel, pnlDayKobo, pnlOpenKobo, positionsValueKobo }: Props) {
  const [mode, setMode] = useState<'live' | 'paper'>('paper');
  const cash = balance?.cash ?? '0';
  const buyingPower = balance?.buyingPower ?? '0';
  const netLiq = (BigInt(cash) + BigInt(positionsValueKobo ?? '0')).toString();

  return (
    <div className="acct-summary">
      <div className="head">
        <h3>ⓘ Account Summary</h3>
        <div className="toggle" role="tablist" aria-label="Trading mode">
          <button
            role="tab"
            aria-selected={mode === 'live'}
            className={mode === 'live' ? 'active live' : ''}
            onClick={() => setMode('live')}
          >Live Trading</button>
          <button
            role="tab"
            aria-selected={mode === 'paper'}
            className={mode === 'paper' ? 'active paper' : ''}
            onClick={() => setMode('paper')}
          >paperMoney<sup>®</sup></button>
        </div>
      </div>
      <select aria-label="Account" value={accountLabel} onChange={() => { /* single account in pilot */ }}>
        <option>{accountLabel || 'All Accounts'}</option>
      </select>
      {mode === 'paper' && (
        <div className="paper-note">⚠ PAPER — Practice Mode (NSM virtual)</div>
      )}
      <div className="row"><span className="k">Net Liquidation</span><span className="v">{koboToNaira(netLiq)}</span></div>
      <div className="row"><span className="k">Buying Power</span><span className="v">{koboToNaira(buyingPower)}</span></div>
      <div className="row"><span className="k">Cash & Sweep</span><span className="v">{koboToNaira(cash)}</span></div>
      <div className="row">
        <span className="k">P/L Day</span>
        <span className={`v ${Number(pnlDayKobo ?? '0') >= 0 ? 'up' : 'down'}`}>
          {koboToNaira(pnlDayKobo ?? '0')}
        </span>
      </div>
      <div className="row">
        <span className="k">P/L Open</span>
        <span className={`v ${Number(pnlOpenKobo ?? '0') >= 0 ? 'up' : 'down'}`}>
          {koboToNaira(pnlOpenKobo ?? '0')}
        </span>
      </div>
      <div className="meta">NGX 09:30 – 14:30 WAT &nbsp;·&nbsp; Settlement T+2</div>
    </div>
  );
}
